import config from '@/utils/ApiUtils'
import { fetchWithToken } from '../utils/Keycloak'

const handleResponse = (response) => {
  if (!response.ok) {
    return response.text().then((text) => {
      let message = `Keycloak Auth API error (${response.status}): ${text}`
      if (response.status === 409) {
        try {
          const body = JSON.parse(text)
          const raw = body.message || body.error || text
          if (/same username/i.test(raw)) message = 'Un compte avec ce nom d\'utilisateur existe déjà.'
          else if (/same email/i.test(raw)) message = 'Un compte avec cet email existe déjà.'
          else message = raw
        } catch (_) { /* non-JSON response */ }
      }
      throw new Error(message)
    })
  }
  if (response.status === 204) return null
  const contentType = response.headers.get('content-type') || ''
  if (!contentType.includes('application/json')) return null
  return response.json()
}

export default {
  // ===== Users CRUD =====
  listUsers (params = {}) {
    const query = new URLSearchParams(
      Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
    ).toString()
    const suffix = query ? `?${query}` : ''
    return fetchWithToken(`${config().keycloakAuthBackend}users${suffix}`, { method: 'GET' }).then(handleResponse)
  },

  getUser (id) {
    return fetchWithToken(`${config().keycloakAuthBackend}users/${encodeURIComponent(id)}`, { method: 'GET' }).then(handleResponse)
  },

  createUser (payload) {
    return fetchWithToken(`${config().keycloakAuthBackend}users`, {
      method: 'POST',
      body: JSON.stringify(payload),
    }).then(handleResponse)
  },

  updateUser (id, payload) {
    return fetchWithToken(`${config().keycloakAuthBackend}users/${encodeURIComponent(id)}`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    }).then(handleResponse)
  },

  deleteUser (id) {
    return fetchWithToken(`${config().keycloakAuthBackend}users/${encodeURIComponent(id)}`, { method: 'DELETE' }).then(handleResponse)
  },

  resetPassword (id, password, temporary = true) {
    return fetchWithToken(`${config().keycloakAuthBackend}users/${encodeURIComponent(id)}/reset-password`, {
      method: 'POST',
      body: JSON.stringify({ password, temporary }),
    }).then(handleResponse)
  },

  logoutUser (id) {
    return fetchWithToken(`${config().keycloakAuthBackend}users/${encodeURIComponent(id)}/logout`, { method: 'POST' }).then(handleResponse)
  },

  // ===== Roles =====
  listAllRoles () {
    return fetchWithToken(`${config().keycloakAuthBackend}roles`, { method: 'GET' }).then(handleResponse)
  },

  getUserRoles (id) {
    return fetchWithToken(`${config().keycloakAuthBackend}users/${encodeURIComponent(id)}/roles`, { method: 'GET' }).then(handleResponse)
  },

  assignUserRole (id, role) {
    return fetchWithToken(`${config().keycloakAuthBackend}users/${encodeURIComponent(id)}/roles`, {
      method: 'POST',
      body: JSON.stringify({ role }),
    }).then(handleResponse)
  },

  removeUserRole (id, role) {
    return fetchWithToken(`${config().keycloakAuthBackend}users/${encodeURIComponent(id)}/roles`, {
      method: 'DELETE',
      body: JSON.stringify({ role }),
    }).then(handleResponse)
  },

  // ===== Impersonate =====
  impersonate (clientId, app) {
    return fetchWithToken(`${config().keycloakAuthBackend}impersonate`, {
      method: 'POST',
      body: JSON.stringify({ clientId: String(clientId), app }),
    }).then(handleResponse)
  },

  stopImpersonate (app) {
    return fetchWithToken(`${config().keycloakAuthBackend}impersonate`, {
      method: 'DELETE',
      body: JSON.stringify({ app }),
    }).then(handleResponse)
  },

  getImpersonateStatus () {
    return fetchWithToken(`${config().keycloakAuthBackend}impersonate/me`, { method: 'GET' }).then(handleResponse)
  },

  removeOwnAccount (app) {
    return fetchWithToken(`${config().keycloakAuthBackend}impersonate/account`, {
      method: 'DELETE',
      body: JSON.stringify({ app }),
    }).then(handleResponse)
  },
}
